
import { useState, useEffect } from 'react';

export default function FloatingCallButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 200);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <a
      href="tel:8135429892"
      className={`fixed bottom-8 left-6 z-50 flex items-center gap-3 bg-orange-600 hover:bg-orange-700 text-white px-5 py-3.5 rounded-full shadow-2xl transition-all duration-300 cursor-pointer whitespace-nowrap group ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6 pointer-events-none'
      }`}
      aria-label="Call Cabadas Roofing Now"
    >
      <span className="w-9 h-9 flex items-center justify-center bg-white/20 rounded-full group-hover:bg-white/30 transition-colors">
        <i className="ri-phone-fill text-white text-lg"></i>
      </span>
      <div className="flex flex-col leading-tight">
        <span className="text-xs font-medium text-orange-100">Call Now — Free Estimate</span>
        <span className="text-base font-bold tracking-wide">(813) 542-9892</span>
      </div>
      <span className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-green-400 rounded-full border-2 border-white animate-pulse"></span>
    </a>
  );
}
